export const RiskAssessmentTypeName = {
  공종: 'discipline',
  재해형태: 'accidentType',
  위험성등급: 'riskGrade',
  유해위험요인: 'riskFactorName',
  감소조치자: 'actionUser',
  감소확인자: 'confirmUser',
  작업일정: 'workSchedule',
  감소일정: 'actionSchedule',
  위험성감소대책: 'managementPlan'
};
